import {useEffect,useState} from 'react'
import {Download,Smartphone,Monitor,CheckCircle2} from 'lucide-react'
import {Link} from 'react-router-dom'
import {useAuth} from '../contexts/AuthContext'
import {FamilyContext} from '../contexts/FamilyContext'
import {useContext} from 'react'
import {initInstallation,readFamilyBinding} from '../services/familyInstallationIdentity'
export default function InstallDomus(){
 const [prompt,setPrompt]=useState(null)
 const [installed,setInstalled]=useState(window.matchMedia?.('(display-mode: standalone)').matches||window.navigator.standalone===true)
 const [result,setResult]=useState('')
 const {user}=useAuth()
 const {family}=useContext(FamilyContext)
 const [identity,setIdentity]=useState(null)
 const [linked,setLinked]=useState(null)
 const [identityError,setIdentityError]=useState('')
 useEffect(()=>{
  let alive=true
  initInstallation().then(async record=>{
    const binding=user&&family?.id?await readFamilyBinding({userId:user.id,familyId:family.id}):null
    if(alive){setIdentity(record);setLinked(binding)}
  }).catch(e=>{if(alive)setIdentityError(e.message)})
  return()=>{alive=false}
 },[user?.id,family?.id])
 useEffect(()=>{
  const onPrompt=e=>{e.preventDefault();setPrompt(e)}
  const onInstalled=()=>{setInstalled(true);setPrompt(null);setResult('DOMUS instalado neste dispositivo.')}
  window.addEventListener('beforeinstallprompt',onPrompt)
  window.addEventListener('appinstalled',onInstalled)
  return()=>{window.removeEventListener('beforeinstallprompt',onPrompt);window.removeEventListener('appinstalled',onInstalled)}
 },[])
 const install=async()=>{
  if(!prompt)return
  await prompt.prompt()
  const answer=await prompt.userChoice
  setPrompt(null)
  if(answer?.outcome==='accepted')setResult('Instalação aceite. Verifique o ecrã inicial ou a lista de aplicações.')
 }
 return <div className="max-w-3xl mx-auto p-4 space-y-6">
  <header className="bg-white border rounded-2xl p-6 space-y-2"><h1 className="text-2xl font-bold text-gray-900">Instalar DOMUS SELF FAMILY</h1><p className="text-gray-600">Sem Docker nem comandos. Instale a PWA diretamente no telemóvel ou computador, a partir desta ligação HTTPS.</p></header>
  <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-amber-900"><strong>Versão de pré-visualização</strong><p className="text-sm mt-1">A instalação da interface já está disponível. A ligação definitiva ao Google Drive familiar, os convites e a sincronização entre membros ainda estão em desenvolvimento. Não introduza dados familiares sensíveis nesta versão.</p></div>
  {installed?<div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-center gap-2 text-green-800"><CheckCircle2/> A PWA está aberta no modo instalado.</div>:prompt?<button onClick={install} className="w-full bg-green-700 text-white rounded-xl p-4 flex items-center justify-center gap-2 font-bold"><Download/> Instalar DOMUS neste dispositivo</button>:null}
  {result&&<p role="status" className="text-green-800">{result}</p>}
  <div className="grid sm:grid-cols-2 gap-4">
   <section className="bg-white border rounded-xl p-5 space-y-3"><Smartphone className="text-green-700"/><h2 className="font-bold">iPhone / iPad</h2><p className="text-sm">Abra no Safari, toque em Partilhar e escolha «Adicionar ao Ecrã Principal».</p></section>
   <section className="bg-white border rounded-xl p-5 space-y-3"><Monitor className="text-green-700"/><h2 className="font-bold">Android / Computador</h2><p className="text-sm">No Chrome ou Edge, utilize «Instalar aplicação» no menu do navegador. Se a opção não aparecer, o navegador pode não suportar a instalação ou ainda não reconhecer a PWA.</p></section>
  </div>
  <section className="bg-white border rounded-xl p-5 space-y-2"><h2 className="font-bold">Reconhecimento familiar automático</h2>
   <p className="text-sm text-gray-600">O Domus cria uma identificação local aleatória e associa a instalação automaticamente depois de confirmar a sessão e a pertença à família. Não recolhe MAC, GPS ou identidade do hardware.</p>
   {identity&&<p className="text-xs text-gray-600 break-all">Instalação local: {identity.id}</p>}
   {linked&&<p className="text-sm text-green-800">Instalação reconhecida na família {family?.name}.</p>}
   {identityError&&<p role="alert" className="text-red-700 text-sm">{identityError}</p>}
  </section>
  <p className="text-sm text-gray-600">Instalar a PWA não cria um servidor doméstico nem ativa a localização contínua. O acesso familiar completo requer a integração Google em desenvolvimento.</p>
  <Link className="text-green-700 underline" to="/dashboard">Abrir o painel DOMUS</Link>
 </div>
}
